/**
 * Compresses the query string by removing whitespace.
 * @param {AxiosRequestConfig} config The Axios request configuration.
 */ export var setGraphQLCompression = function(config) {
    var _config_data;
    if ((_config_data = config.data) == null ? void 0 : _config_data.query) {
        config.data.query = config.data.query.replace(/\s+/g, " ").trim();
    }
    return config;
};
/**
 * If the query is a GraphQL document, extract the query string from the document.
 * @param {AxiosRequestConfig} config The Axios request configuration.
 */ export var setGraphQLFile = function(config) {
    var _config_data_query_loc_source, _config_data_query_loc, _config_data_query;
    var isDocument = (_config_data_query = config.data.query) == null ? void 0 : (_config_data_query_loc = _config_data_query.loc) == null ? void 0 : (_config_data_query_loc_source = _config_data_query_loc.source) == null ? void 0 : _config_data_query_loc_source.body;
    if (isDocument) {
        config.data.query = config.data.query.loc.source.body;
    }
    return config;
};
